module.exports = {"attributes":{"width":"21","height":"37","viewBox":"0 0 21 37","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M18.7092271,17.0278016 C18.9114457,17.2300201 19.0073207,17.4988888 18.9995648,17.7641768 C19.0073873,18.0287111 18.9097709,18.2963448 18.7054711,18.5006447 L2.44182093,34.7079456 C2.05307078,35.0966958 1.42491839,35.0988319 1.03155756,34.7054711 L0.32297513,33.9968887 C-0.0671416735,33.6067719 -0.0614743556,32.9686002 0.32050059,32.5866253 L15.1410248,17.7661011 L0.316744599,2.94182093 C-0.0720055539,2.55307078 -0.0741416971,1.92491839 0.319219139,1.53155756 L1.02780157,0.82297513 C1.41791837,0.432858327 2.05609,0.438525644 2.43806494,0.82050059 L18.7092271,17.0278016 Z\" transform=\"translate(1 1)\" stroke=\"currentColor\" fill=\"currentColor\" fill-rule=\"evenodd\" stroke-opacity=\".15\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
